import React from 'react';
import { MainLangType } from 'types/mainPage';
import globe from 'globe-icon.svg';
import { Box, Typography } from '@mui/material';

export const MainTitle: React.FC<{ lang: MainLangType }> = ({ lang }) => {
  switch (lang) {
    case 'en': {
      return (
        <Box sx={{ display: 'flex', alignItems: 'end' }}>
          <Typography sx={{ fontSize: '28px', lineHeight: '1.1' }}>
            GE
          </Typography>
          <img
            src={globe}
            alt="main-logo"
            style={{ width: 37, alignSelf: 'center' }}
          />
          <Typography sx={{ fontSize: '28px', lineHeight: '1.1', ml: -0.5 }}>
            STATISTICS
          </Typography>
        </Box>
      );
    }
    case 'ru': {
      return (
        <Box sx={{ display: 'flex', alignItems: 'end' }}>
          <Typography sx={{ fontSize: '28px', lineHeight: '1.1' }}>
            ГЕ
          </Typography>
          <img
            src={globe}
            alt="main-logo"
            style={{ width: 37, alignSelf: 'center' }}
          />
          <Typography sx={{ fontSize: '28px', lineHeight: '1.1', ml: -0.5 }}>
            СТАТИСТИКА
          </Typography>
        </Box>
      );
    }
    case 'by': {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={globe}
            alt="main-logo"
            style={{ width: 37, alignSelf: 'center' }}
          />
          <Typography sx={{ fontSize: '28px' }}>ГЕАСТАТЫСТЫКА</Typography>
        </Box>
      );
    }
    default: {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography>ГЕ</Typography>
          <img src={globe} alt="main-logo" />
          <Typography>СТАТИСТИКА</Typography>
        </Box>
      );
    }
  }
};
